import { useWorkspaceText, type WorkspaceText } from '../interface-copy';
import { useNamespaceCopy } from '@/i18n/ns';
import workspaceFeaturesCopy from '@/i18n/ns/workspace-features';
import { WorkspaceIcon } from '../icons';
import type { Agent } from './api';

type RunProps = {
  agent: Agent;
  busy: boolean;
  onRun: () => Promise<void>;
  /** The canvas header's primary action. */
  primary?: boolean;
};

function unavailableReason({ agent, busy }: RunProps, uiText: WorkspaceText) {
  if (!agent.publishedRevision) return uiText('Publish a version first.');
  return busy ? uiText('Another Agent action is in progress.') : '';
}

/** Manual runs are available whether a schedule is enabled or paused. */
export function AgentRunButton(props: RunProps) {
  const { text: uiText, rich: uiRich } = useWorkspaceText();
  const copy = useNamespaceCopy(workspaceFeaturesCopy);
  if (!props.agent.access.run) return null;
  const reason = unavailableReason(props, uiText);
  return (
    <button
      className={props.primary ? 'ws-button primary' : 'ws-button'}
      aria-label={copy.runNow}
      aria-disabled={Boolean(reason)}
      title={reason || uiText('Run the published version once')}
      onClick={() => {
        if (!reason) void props.onRun();
      }}
    >
      <WorkspaceIcon name="play" size={props.primary ? 14 : 16} />
      {copy.runNow}
    </button>
  );
}
